import React from 'react';
import Loading from '../loading/Loading';
import { withAuthenticationRequired } from '@auth0/auth0-react';

const AuthRequiredWrapper = ({ children }) => children;

export default withAuthenticationRequired(AuthRequiredWrapper, {
    onRedirecting: () => <Loading loading={true} />
});
